import(/* webpackMode: "eager" */ "/vercel/path0/components/molecules/cards/slideshow-box.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/organisms/slider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
